import { ref } from 'vue'

const STORAGE_KEY = 'chat-matrix-fast:message-drafts'
const LEGACY_STORAGE_KEY = 'chat-matrix:message-drafts'

/** Реактивная карта черновиков — список чатов читает отсюда. */
export const messageDrafts = ref<Record<string, string>>({})

let hydrated = false

function hydrate(): void {
  if (hydrated) return
  hydrated = true

  function readDrafts(key: string): Record<string, string> {
    try {
      const parsed = JSON.parse(localStorage.getItem(key) ?? '{}') as Record<string, unknown>
      if (!parsed || typeof parsed !== 'object' || Array.isArray(parsed)) return {}
      return Object.fromEntries(Object.entries(parsed)
        .filter((entry): entry is [string, string] => typeof entry[1] === 'string' && Boolean(entry[1].trim())))
    } catch {
      return {}
    }
  }

  const legacy = readDrafts(LEGACY_STORAGE_KEY)
  messageDrafts.value = { ...legacy, ...readDrafts(STORAGE_KEY) }
  if (Object.keys(legacy).length) {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(messageDrafts.value))
      localStorage.removeItem(LEGACY_STORAGE_KEY)
    } catch {
      // Keep the legacy copy if the merged drafts could not be persisted.
    }
  }
}

function persist(): void {
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(messageDrafts.value))
  } catch {
  }
}

function draftKey(chatId: string | number): string {
  return String(chatId)
}

export function getMessageDraft(chatId: string | number | null | undefined): string {
  if (chatId == null) return ''
  hydrate()
  return messageDrafts.value[draftKey(chatId)] ?? ''
}

/** Сохраняет текст черновика; пустой — удаляет. */
export function setMessageDraft(
  chatId: string | number | null | undefined,
  text: string,
): void {
  if (chatId == null) return
  hydrate()

  const key = draftKey(chatId)
  if (!text.trim()) {
    if (!(key in messageDrafts.value)) return
    const next = { ...messageDrafts.value }
    delete next[key]
    messageDrafts.value = next
    persist()
    return
  }

  if (messageDrafts.value[key] === text) return
  messageDrafts.value = { ...messageDrafts.value, [key]: text }
  persist()
}

export function clearMessageDraft(chatId: string | number | null | undefined): void {
  setMessageDraft(chatId, '')
}
